/**
 * Stops a request that never gets a reply from hanging forever.
 * @module lib/services/request/timeout/middleware.js
 */

/**
 * Sits deliberately above Brooklyn's 30s timeouts (node `server.timeout`, the
 * nginx ingress `proxy-read-timeout` and CloudFront's origin read timeout) so
 * the server wins the race and answers with a 504 we can read, instead of us
 * aborting first and reporting a bare network error.
 */
export const REQUEST_TIMEOUT_MS = 34000

/**
 * Returns a modified request object that gives up if the server has not
 * started replying within the timeout. This is a response timeout rather than
 * a deadline, so a large upload that is still transferring is left alone.
 *
 * @param {Object} req - The HTTP request object.
 * @returns {Object} The modified request object.
 */
export const timeoutMiddleware = (req) => {
  req.timeout({ response: REQUEST_TIMEOUT_MS })
  return req
}
